import { commonAxios } from "../utils/AxiosSettings";
export async function caseReportFileUpload(formData, caseData) {
    const res = await commonAxios.put(
        `${process.env.REACT_APP_BASE_URL_API}/api/accounts/Cases/${caseData.id}`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );

    return res;
}

export async function getCaseSettingsOfCompany(company) {
    const res = await commonAxios.get(
        `${process.env.REACT_APP_BASE_URL_API}/api/accounts/casesetting/${company}`
    );

    return res;
}
export async function patchFileUpload(formData, userData) {
    const res = await commonAxios.patch(
        `${process.env.REACT_APP_BASE_URL_API}/api/accounts/baseuser/${userData.id}`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );

    return res;
}
export async function UploadImage() {}

export async function createNewCaseWithFile(formData) {
    const res = await commonAxios.post(
        `${process.env.REACT_APP_BASE_URL_API}/api/accounts/CaseswithFileUpload/`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );

    return res;
}

export async function getNumberOfCases() {
    const res = await commonAxios.get(
        `${process.env.REACT_APP_BASE_URL_API}/api/accounts/caseCount/`
    );
    return res;
}

export async function inPersonCaseUploaderWithoutFile(caseObject) {
    const res = await commonAxios.post(
        `${process.env.REACT_APP_BASE_URL_API}/api/accounts/case/upload/`,
        caseObject
    );

    return res;
}

export async function caseMessageSaver(messageCase, caseData) {
    const res = await commonAxios.post(
        `${process.env.REACT_APP_BASE_URL_API}/api/accounts/caseMessager/`,
        {
            Message: messageCase,
            Case: caseData.id,
        }
    );

    return res;
}

export async function getCaseDetailsByID(caseID, version) {
    let url = `${process.env.REACT_APP_BASE_URL_API}/api/accounts/Cases/${caseID}`;

    if (version) {
        url += `?version=${version}`;
    }

    const res = await commonAxios.get(url);

    return res;
}
export async function getViewLog(caseID, token) {
    //reimplement this using useQuery and useParam hook
    const res = await commonAxios.get(
        `${process.env.REACT_APP_BASE_URL_API}/api/accounts/logs/?case=${caseID}`
        // {
        //     headers: {
        //         Authorization: `Bearer ${token}`,
        //     },
        // }
    );
    return res;
}
